import { FetchRequestActions } from '../../../utils/request-actions-helpers/createRequestActions';
import { ApiConfig } from '../../../config'
import { processEventsResponse } from "./processEventsResponse";
import { Document } from '../../../models'
import { createRequestActionTypes } from "../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../utils/request-actions-helpers/createRequestThunk";
import { Dispatch } from 'redux';
import { AppStateWithData } from '../../AppStateWithData';

export const fecthFeedWidgetEventsActionTypes = createRequestActionTypes('EVENTS')

export type FeedEventsActions = FetchRequestActions<Document[]>

export const getEvents = (config: ApiConfig) => (page: number) => (dispatch: Dispatch, getState: () => AppStateWithData) => {

    const thunkParams: RequestThunkParameters<Document[]> = {
        method: 'GET',
        requestActionTypes: fecthFeedWidgetEventsActionTypes,
        processResultBeforeDispatch: processEventsResponse(dispatch),
        url: `${config.API_URL}/calendar?page=${page}`,
    }

    dispatch<any>(createRequestThunk(thunkParams))
}